import React from 'react';

import TaxidermyTanSVG from '../../../assets/images/services/taxidermy-tan.svg';
import TaxidermyTanWEBP from '../../../assets/images/services/taxidermy-tan.webp';
import Formula399SVG from '../../../assets/images/services/formula-399.svg';
import BriteWhiteSVG from '../../../assets/images/services/brite-white.svg';
import AfricanSkinsWEBP from '../../../assets/images/services/african-skins.webp';
import AfricanSkinSVG from '../../../assets/images/services/african-skins.svg';
import FurDressingSVG from '../../../assets/images/services/fur-dressing.svg';
import FurDressingWEBP from '../../../assets/images/services/fur-dressing.webp';
import BisonUltraSVG from '../../../assets/images/services/bison-ultra.svg';
import BisonUltraWEBP from '../../../assets/images/services/bison-ultra.webp';

export default function Tanning() {
    return (
        <>
            <h1 className="double">Tanning Services</h1>
            <div>
                <h2>TAXIDERMY TAN</h2>
                <img src={TaxidermyTanSVG} alt="TAXIDERMY TAN icon" />
                <p>
                    Our taxidermy tanning processes were developed with the following goal in mind:
                    produce easy to mount skins with durable shelf lives while incorporating fur
                    processing techniques that allow for cleaner and more appealing finished mounts.
                    To be successful this task requires us to break down taxidermy tanning into
                    several different processes for unique skin groups. While all of our processes
                    are good, the following is a sampling of a couple of our more outstanding
                    processes:
                </p>
            </div>
            <img src={TaxidermyTanWEBP} width="100%" alt="TAXIDERMY TAN" />
            <div>
                <img className="border" src={Formula399SVG} alt="FORMULA 399" />
                <h3>FORMULA 399</h3>
                <p>
                    Since 2001 we have been working toward producing a deer cape that satisfies both
                    our standards and those of the most demanding taxidermist. After 399 trials we
                    have finally done it. The result is Formula-399: a process for tanning deer
                    capes we can truly be proud of (Process includes other hollow hair game such as
                    elk, moose, caribou, etc.). In Formula-399 we combine fur dressing techniques
                    with the taxidermist&apos;s need for trouble-free mounting to deliver a product
                    that is easy to work with and is beautiful when finished.
                </p>
                <p>Formula-399 benefits:</p>
                <ul>
                    <li>Cleanliness</li>
                    <li>Beautiful hair color and shine</li>
                    <li>Soft, supple leather</li>
                    <li>Well-shaven skin</li>
                    <li>A lifetime-secure shelf life</li>
                    <li>Easy mounting</li>
                    <li>Plasticity (streches without being ruberry)</li>
                </ul>
            </div>
            <div>
                <img className="border" src={BriteWhiteSVG} alt="BriteWhite" />
                <h3>BriteWhite</h3>
                <p>
                    This process, perhaps more than any other, exemplifies the benefits of having a
                    broad scope of experience. Our expertise gained from years of fur dressing is
                    employed here to deliver a complete process of tanning, bleaching, and
                    brightening mountain goats and white wooly sheep for taxidermy. This process is
                    expensive, but well worth it and automatic for all mountain goats and white
                    wooly sheep.
                </p>
                <p>BriteWhite benefits:</p>
                <ul>
                    <li>Professional light bleaching</li>
                    <li>Clean, unmatted, dust-free hair and wool</li>
                    <li>Sophisticated brightening</li>
                    <li>Easy mounting</li>
                </ul>
            </div>
            <hr className="double" />
            <img className="go-8" src={AfricanSkinsWEBP} width="100%" alt="AFRICAN SKINS" />
            <div>
                <h2>AFRICAN SKINS</h2>
                <img src={AfricanSkinSVG} alt="AFRICAN SKINS icon" />
                <h3>TANNING AFRICAN SKINS NOW AVAILABLE!</h3>
                <p>
                    We did this right and took our time. Working with an exclusive group of
                    taxidermy clients over years, our African tanning service is now ready for the
                    most discerning taxidermists.
                </p>
                <ul>
                    <li>Wet tan only for mounts, hides are finished dry tan.</li>
                    <li>
                        No Rhinos, Elephants, or Giraffes at this time. (Have patience, it&apos;s
                        coming.)
                    </li>
                    <li>
                        Use our on-line portal to enter your order and we will take 30 days off your
                        turn-around time at no extra charge.
                    </li>
                </ul>
            </div>
            <hr className="double" />
            <div>
                <h2>INTACT FUR DRESSING</h2>
                <img src={FurDressingSVG} alt="INTACT FUR DRESSING icon" />
                <p>
                    Employed in the dressing of fur bearers, this process uses slightly modified fur
                    dressing techniques to provide garment-quality softness, cleanliness, and
                    free-flowing fur on intact skins that can be used either in the production of
                    garments and crafts or as wall-hangers. Our consistent dedication to quality and
                    vast experience has made us the market leader in this area. Few, if any, of our
                    competitors are able to deliver intact fur dressing as light, soft, and clean on
                    such a consistent basis, a fact that has led us to become the Official Tannery
                    of the National Trappers Association.
                </p>
                <p>
                    For fur bearers that are not going to be mounted, we recommend this process. Our
                    use of sophisticated fur dressing techniques will provide an excellent service
                    that is budget friendly. There is no surcharge for cased skins or intact legs;
                    volume discounts are available. These skins must be fleshed as usual and may be
                    received either salted or trapper dried. Note: This process is not suitable for
                    pieces intended to be mounted. You must specify on your order form Taxidermy
                    Tanning or Intact Fur Dressing for all fur bearers.
                </p>
            </div>
            <img src={FurDressingWEBP} width="100%" alt="INTACT FUR DRESSING" />
            <hr className="double" />
            <img className="go-14" src={BisonUltraWEBP} width="100%" alt="BISON ULTRA" />
            <div>
                <h2>BISON ULTRA</h2>
                <img src={BisonUltraSVG} alt="BISON ULTRA icon" />
                <p>
                    Simply the best. Processing over 2,000 bison hides a year inspired us to develop
                    the Bison Ultra process, a service we provide at a very competitive price thanks
                    to our proficiency. Sophisticated dressing methods yield the lightest and
                    softest bison leather with free-flowing, unmatted, and dust-free hair. Whether
                    for garments or throws, you will be ultrasatisfied with this process and its
                    budget- friendly price.
                </p>
            </div>
            <div>
                <h3>CUSTOM DESIGNED PROCESSING</h3>
                <p>
                    Dedication to quality leads to the inevitable conclusion that a one size fits
                    all tanning process does not exist. A custom-designed process is necessary to
                    achieve outstanding results for each skin type, keeping in mind the skin&apos;s
                    final intended use. We are professional dressers and tanners, and developing
                    custom processes to meet our customers needs is our specialty. This customized
                    approach takes years to perfect, and we thank all the professional taxidermists,
                    furriers, and craftsmen who have consulted with us in the development of our
                    tanning processes.
                </p>
            </div>
            <div>
                <h3>FLAT RATE PRICING</h3>
                <p>
                    We believe pricing should be straightforward and our customers should know what
                    their tanning will cost before the job is done. We charge a flat rate for
                    everything, from bears and mountain lions to elk flats and bison hides. No more
                    guessing how much to charge your customer at Moyle Mink & Tannery it is right on
                    the price list. For miscellaneous quarter hides or pieces we charge $20.00 per
                    pound of raw salted weight, so you can weigh your miscellaneous pieces and know
                    exactly what they will cost.
                </p>
            </div>
            <div>
                <h3>TURN AROUND TIME</h3>
                <p>Dependent on time of year</p>
            </div>
            <div>
                <h3>40-DAY RUSH SERVICE</h3>
                <p>
                    40-Day Rush service is available for 50% surcharge and will depend on the time
                    of year.
                </p>
            </div>
            <div>
                <h3>90-DAY GUARANTEE SERVICE</h3>
                <p>
                    90-Day Guarantee service available for a 10% surcharge. (not available on Bison
                    or Cattle hides)
                </p>
            </div>
        </>
    );
}
